export var COBRANZA_PAGE_TITLE = "Cobranza";
export var COBRANZA_PAGE_SUBTITLE = "Generación y seguimiento de cobros mensuales de pólizas";
export var COBRANZA_GENERATE_BUTTON_LABEL = "Generar Cobro";
export var COBRANZA_APPLY_PAYMENTS_LABEL = "Aplicar Pagos";
export var COBRANZA_PAYMENTS_SUMMARY_LABEL = "Resumen de pagos";
export var COBRANZA_APPLY_PAYMENTS_BLOCKED_STATUSES = [
    "GENERATING_BANK_FILE",
    "FAILED",
];
export var COBRANZA_REPORT_BUTTON_LABEL = "Reporte de pagos y rechazos";
export var COBRANZA_EMPTY_DETAIL_TITLE = "Sin selección";
export var COBRANZA_EMPTY_DETAIL_TEXT = "Seleccioná una cobranza de la lista para ver el detalle.";
export var COBRANZA_DEFAULT_COLLECTION_OPTION = "Cobranza mensual normal";
export var COBRANZA_STATUS_FILTER_LABEL = "Estado";
export var COBRANZA_STATUS_FILTERS = [
    { value: "ALL", label: "Todos" },
    { value: "BANK_PAYMENT_PENDING", label: "En Proceso" },
    { value: "COMPLETED", label: "Completado" },
    { value: "FAILED", label: "Fallido" },
    { value: "PROCESSING_BANK_FILE", label: "Procesando Pagos" },
    { value: "GENERATING_BANK_FILE", label: "Generando archivo" },
];
export var COBRANZA_PAGE_SIZE = 9;
export var COBRANZA_SUMMARY_VISIBLE_STATUSES = [
    "BANK_PAYMENT_PENDING",
    "COMPLETED",
    "PROCESSING_BANK_FILE",
];
export var COBRANZA_SUMMARY_SECTION_LABEL = "Resumen de cobranza";
export var COBRANZA_SUMMARY_POLICIES_LABEL = "Pólizas";
export var COBRANZA_SUMMARY_AMOUNT_LABEL = "Monto a cobrar";
export var COBRANZA_SUMMARY_PAYMENT_METHOD_LABEL = "Medio de cobro";
export var COBRANZA_SUMMARY_CURRENCY_SYMBOL = "RD$";
var pluralize = function (count, singular, plural) {
    return count === 1 ? singular : plural;
};
export var COBRANZA_SUMMARY_PAYMENT_METHOD_SEPARATOR = "·";
export var cobranzaSummaryCardsUnit = function (count) {
    return pluralize(count, "tarjeta", "tarjetas");
};
export var cobranzaSummaryAccountsUnit = function (count) {
    return pluralize(count, "cuenta", "cuentas");
};
var ACCOUNT_NOT_FOUND_LABELS = [
    "póliza sin cuenta registrada",
    "pólizas sin cuenta registrada",
];
var REJECTION_LABELS = {
    account_not_found: ACCOUNT_NOT_FOUND_LABELS,
    "account not found": ACCOUNT_NOT_FOUND_LABELS,
    "backdated - later period already billed": [
        "póliza con un período posterior ya facturado",
        "pólizas con un período posterior ya facturado",
    ],
    "already emitted for this billing period": [
        "póliza ya emitida en este período de facturación",
        "pólizas ya emitidas en este período de facturación",
    ],
    "cancelled previous billing": [
        "póliza con una facturación anterior cancelada",
        "pólizas con una facturación anterior cancelada",
    ],
};
var normalizeRejectionReason = function (reason) {
    return reason.trim().toLowerCase();
};
var REJECTION_PATTERNS = [
    {
        pattern: /^latest (\d+) installments? cancelled$/,
        labels: function (value) {
            return value === "1"
                ? [
                    "póliza con su última cuota cancelada",
                    "pólizas con su última cuota cancelada",
                ]
                : [
                    "p\u00F3liza con sus \u00FAltimas ".concat(value, " cuotas canceladas"),
                    "p\u00F3lizas con sus \u00FAltimas ".concat(value, " cuotas canceladas"),
                ];
        },
    },
];
var rejectionLabelsOf = function (reason) {
    var key = normalizeRejectionReason(reason);
    if (REJECTION_LABELS[key])
        return REJECTION_LABELS[key];
    for (var _i = 0, REJECTION_PATTERNS_1 = REJECTION_PATTERNS; _i < REJECTION_PATTERNS_1.length; _i++) {
        var rule = REJECTION_PATTERNS_1[_i];
        var match = key.match(rule.pattern);
        if (match)
            return rule.labels(match[1]);
    }
    return undefined;
};
export var cobranzaRejectionTitle = function (reason, count) {
    var labels = rejectionLabelsOf(reason);
    return labels
        ? "".concat(count, " ").concat(pluralize(count, labels[0], labels[1]))
        : "".concat(count, " ").concat(pluralize(count, "póliza", "pólizas"), " \u00B7 ").concat(reason);
};
export var COBRANZA_REJECTED_POLICIES_ACTION = "Ver pólizas";
export var COBRANZA_REJECTED_POLICIES_PAGE_SIZE = 10;
export var COBRANZA_REJECTED_POLICIES_PAGINATION_LABEL_OF = "de";
export var COBRANZA_REJECTED_POLICIES_SUBTITLE = "Pólizas que no entraron al archivo de cobro por este motivo.";
export var COBRANZA_REJECTED_POLICY_CODE_LABEL = "Código de póliza";
export var COBRANZA_REJECTED_POLICY_NAME_LABEL = "Asegurado";
export var COBRANZA_REJECTED_POLICY_NO_CODE = "Sin código";
export var COBRANZA_REJECTED_POLICY_NO_NAME = "Sin nombre";
